import { apiGet } from './client';

/** One bank-file ingestion RUN — see dbo.BankImportLog (tenant). */
export interface BankImportLogRow {
  logId: number;
  bankId: number;
  importId: number | null;
  importName: string | null;
  importBatchId: string;
  /** The files' as-of date — NOT when we ran it (a post-holiday file is dated days back). */
  valueDate: string | null;
  sourceKind: string | null;
  filePattern: string | null;
  fileNames: string | null;
  /** Local time, already converted server-side (the column is UTC). */
  startedAt: string;
  finishedAt: string | null;
  durationMs: number | null;
  status: 'running' | 'success' | 'failed';
  filesReceived: number | null;
  filesLoaded: number | null;
  rowsLoaded: number | null;
  messages: string | null;
  createdBy: string | null;
}

export function getBankImportLog(
  fromDate: string,
  toDate: string,
): Promise<BankImportLogRow[]> {
  const q = new URLSearchParams({ fromDate, toDate });
  return apiGet<BankImportLogRow[]>(`/api/bank-files/import-log?${q.toString()}`);
}
